import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage, useIntl } from 'react-intl';

import LandingSection from '../../../MyComponents/LandingSections/LandingSection';
import SectionEyebrow from '../../../MyComponents/LandingSections/SectionEyebrow';
import { REDESIGN_COLORS, REDESIGN_FONTS } from '../../../constants';

const TESTIMONIALS = ['1', '2', '3'];
const STARS = [0, 1, 2, 3, 4];

const useStyles = makeStyles(() => ({
    eyebrowRow: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '16px',
    },
    grid: {
        display: 'grid',
        // auto-fit collapses 3 -> 2 -> 1 column on its own; `min(100%, 240px)`
        // keeps the track from outgrowing a narrow viewport.
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 240px), 1fr))',
        gap: '30px 40px',
        alignItems: 'start',
    },
    item: {
        maxWidth: '330px',
        margin: '0 auto',
        textAlign: 'center',
    },
    stars: {
        display: 'flex',
        justifyContent: 'center',
        gap: '3px',
        marginBottom: '9px',
    },
    quote: {
        margin: '0 0 7px',
        color: REDESIGN_COLORS.dark,
        fontSize: '0.86rem',
        fontStyle: 'italic',
        // 750 interpolates on the variable font, between Manrope's 700 and 800.
        fontWeight: 750,
        lineHeight: 1.55,
        textWrap: 'pretty',
    },
    cite: {
        display: 'block',
        color: REDESIGN_COLORS.body,
        fontSize: '0.72rem',
        fontStyle: 'normal',
        fontWeight: REDESIGN_FONTS.weightHeading,
    },
}));

const Star = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill={REDESIGN_COLORS.highlight} aria-hidden="true">
        <path d="M12 2.5l2.9 6.1 6.6.9-4.8 4.6 1.2 6.6L12 17.6 6.1 20.7l1.2-6.6L2.5 9.5l6.6-.9z" />
    </svg>
);

/**
 * The testimonials band between the hero and the product video: three short
 * five-star quotes under a single eyebrow, with no heading of their own.
 */
const HomeTestimonials = () => {
    const classes = useStyles();
    const intl = useIntl();

    return (
        <LandingSection paddingTop={72} paddingBottom={48}>
            <div className={classes.eyebrowRow}>
                <SectionEyebrow>
                    <FormattedMessage id="redesign.home.testimonials.eyebrow" />
                </SectionEyebrow>
            </div>

            <div className={classes.grid}>
                {TESTIMONIALS.map((n) => (
                    <article key={n} className={classes.item}>
                        <div
                            className={classes.stars}
                            role="img"
                            aria-label={intl.formatMessage({ id: 'redesign.home.testimonials.stars' })}
                        >
                            {STARS.map((i) => (
                                <Star key={i} />
                            ))}
                        </div>
                        <blockquote className={classes.quote}>
                            <FormattedMessage id={`redesign.home.testimonials.quote${n}`} />
                        </blockquote>
                        <cite className={classes.cite}>
                            <FormattedMessage id={`redesign.home.testimonials.cite${n}`} />
                        </cite>
                    </article>
                ))}
            </div>
        </LandingSection>
    );
};

export default HomeTestimonials;
